<template>
    <div class="stepper-step" v-show="isVisible">
        <div class="stepper-step__buttons h:margin-bottom-8" v-if="showButtonsAbove">
            <div class="page-control">
                <div class="page-control__element" v-if="!isFirstElement">
                    <button
                        @click.prevent="goToPreviousGlobalStep"
                        :disabled="previousDisabled"
                        class="btn btn--big btn--tertiary">
                            {{ computedPreviousButtonText }}
                    </button>
                </div>
                <div class="page-control__element" :class="isFirstElement ? 'page-control__element--full-width' : ''">
                    <once-button
                        type="primary"
                        :btnClasses="['btn', 'btn--big', 'btn--primary']"
                        :text="computedNextButtonText"
                        :spinner="nextButtonSpinner"
                        :additionalDisable="!nextEnabled"
                        :click="goToNextGlobalStep"
                    ></once-button>
                </div>
            </div>
        </div>
        <div class="stepper-step__content h:margin-bottom-8">
            <slot></slot>
        </div>
        <div class="stepper-step__buttons" v-if="showButtonsBelow">
            <div class="page-control">
                <div class="page-control__element" v-if="!isFirstElement">
                    <button
                        @click.prevent="goToPreviousGlobalStep"
                        :disabled="previousDisabled"
                        class="btn btn--big btn--tertiary">
                            {{ computedPreviousButtonText }}
                    </button>
                </div>
                <div class="page-control__element" :class="isFirstElement ? 'page-control__element--full-width' : ''">
                    <once-button
                        type="primary"
                        :btnClasses="['btn', 'btn--big', 'btn--primary']"
                        :text="computedNextButtonText"
                        :spinner="nextButtonSpinner"
                        :additionalDisable="!nextEnabled"
                        :click="goToNextGlobalStep"
                    ></once-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus.js';

/**
 * @todo When this is changed more often, stepperStepButtons should be own component
 */
export default {
    props: {
        // Number starts with 0
        number: {
            type: Number,
            required: true
        },
        previousButtonText: String,
        nextButtonText: String,
        isLastStep: Boolean,
        nextEnabled: {
            type: Boolean,
            default: true
        },
        previousDisabled: Boolean,
        showButtonsAbove: Boolean,
        showButtonsBelow: {
            type: Boolean,
            default: true
        },
        checkBeforeGoToNext: {
            type: Function,
            default: () => { return new Promise((resolve) => resolve(true)); },
        },
    },

    data() {
        return {
            currentGlobalStep: 0,
            nextButtonSpinner: false
        }
    },
   computed: {
       isFirstElement() {
           return this.number === 0;
       },

       isVisible() {
           return this.number === this.currentGlobalStep;
       },

        computedPreviousButtonText() {
            if (this.previousButtonText) {
                return this.previousButtonText;
            }

            return this.trans('buttons.back');
        },

       computedNextButtonText() {
           if (this.nextButtonText) {
               return this.nextButtonText;
           }

           if (this.isLastStep) {
               return this.trans('buttons.submit');
           }

            return this.trans('buttons.next');
       }
    },

    methods: {
        goToNextGlobalStep(event) {
            event.preventDefault();
            this.nextButtonSpinner = true;
            this.checkBeforeGoToNext()
            .then((result) => {
                if (!result) {
                    this.nextButtonSpinner = false;
                    return;
                }

                if (!this.isLastStep) {
                    this.nextButtonSpinner = false;
                    EventBus.$emit('changeStepperTo', this.number+1);
                }

                if (this.isLastStep) {
                    EventBus.$emit('submitForm');
                }
            });
        },

        goToPreviousGlobalStep() {
            EventBus.$emit('changeStepperTo', this.number-1);
        }
    },

    mounted() {
        EventBus.$on('changeStepperTo', stepId => {
            this.currentGlobalStep = stepId;
        });
    },
}
</script>
